import { call, put, all, takeLatest } from "redux-saga/effects";
import {
  getListCustomer,
  setListCustomer,
  setListMenu,
  setListStaff,
  setListTable,
  setListParticipants,
  setListSeat,
} from "./actions";
import {
  getListMenu,
  getListStaff,
  getListTable,
  getListParticipants,
  getListSeat,
} from "./api";
import {
  GET_LIST_CUSTOMER,
  GET_LIST_MENU,
  GET_LIST_STAFF,
  GET_LIST_TABLE,
  GET_LIST_PARTICIPANTS,
  GET_LIST_SEAT,
} from "./types";

function* handleGetListMenu(action) {
  try {
    const result = yield call(getListMenu, action.payload);
    const menus = result.data.results;
    yield put(setListMenu(menus));
  } catch (e) {
    // yield put(actions.loginError());
    throw e;
  }
}

function* handleGetListSaff(action) {
  try {
    const result = yield call(getListStaff, action.payload);
    const menus = result.data.results;
    yield put(setListStaff(menus));
  } catch (e) {
    // yield put(actions.loginError());
    throw e;
  }
}

function* handleGetListTable(action) {
  try {
    const result = yield call(getListTable, action.payload);
    const tables = result.data;
    yield put(setListTable(tables));
  } catch (e) {
    throw e;
  }
}

function* handleGetListCustomer(action) {
  try {
    const results = yield call(getListCustomer, action.payload);
    const customer = results.data.results;
    yield put(setListCustomer(customer));
  } catch (e) {
    throw e;
  }
}

function* handleGetListParticipants(action) {
  try {
    const results = yield call(getListParticipants, action.payload);
    const customer = results?.data?.results;
    yield put(setListParticipants(customer || []));
  } catch (e) {
    throw e;
  }
}

function* handleGetlistSeat(action) {
  try {
    const results = yield call(getListSeat, action.payload);
    const seat = results?.data;
    yield put(setListSeat(seat || []));
  } catch (e) {
    throw e;
  }
}

function* appSaga() {
  yield all([
    takeLatest(GET_LIST_MENU, handleGetListMenu),
    takeLatest(GET_LIST_STAFF, handleGetListSaff),
    takeLatest(GET_LIST_TABLE, handleGetListTable),
    takeLatest(GET_LIST_CUSTOMER, handleGetListCustomer),
    takeLatest(GET_LIST_PARTICIPANTS, handleGetListParticipants),
    takeLatest(GET_LIST_SEAT, handleGetlistSeat),
  ]);
}

export default appSaga;
